<ng-container [ngSwitch]="state">
    <div class="navbar" *ngSwitchCase="LayoutState.expanded">
        <a class="navbar_item button-17" href="https://museephemere.fr" target="_top">
            <!-- <img src="assets/img/logo.jpg" alt="logo"> -->
            <div>Muséephemere</div>
        </a>
        <div class="navbar_item button-17" (click)="changeState(LayoutState.menu)">
<!--            <img src="https://lh3.googleusercontent.com/proxy/6X-AkKvCN7Mn9WtuJZZVN9KgLXrjwY0mDx0hePQjXPID2HFMsEnDSuAhfrSASUTWxsTgTvZG1jZnYwRsFqKqKDE8DMIV3z1fd9_mcYhx7eXj">-->
            <div>Menu</div>
        </div>
        <div class="navbar_item button-17" (click)="selectScene(Scenes.FloorPlan)">
            <img src="assets/img/floor-plan.JPG">
            <div>Floor plan</div>
        </div>

        <a class="back-to-landing button-17" href="https://museephemere.fr" target="_top">Retour à la page d'accueil</a>
    </div>

    <div class="menu" *ngSwitchCase="LayoutState.menu">
        <div class="menu_item">
            <div class="button-17" (click)="selectScene(Scenes.Scene1)">
                <img src="assets/img/scene1.JPG">
                <div>Scene 1</div>
            </div>
        </div>
        <div class="menu_item">
            <div class="button-17" (click)="selectScene(Scenes.Scene2)">
                <img src="assets/img/scene2.JPG">
                <div>Scene 2</div>
            </div>
        </div>
        <div class="menu_item">
            <div class="button-17" (click)="selectScene(Scenes.Scene3)">
                <img src="assets/img/scene3.JPG">
                <div>Scene 3</div>
            </div>
        </div>
        <div class="menu_item">
            <div class="button-17" (click)="selectScene(Scenes.Scene4)">
                <img src="assets/img/scene4.JPG">
                <div>Scene 4</div>
            </div>
        </div>
        <div class="menu_floor-plan">
            <div class="button-17" (click)="selectScene(Scenes.FloorPlan)">
                <img src="assets/img/floor-plan.JPG">
                <div>Floor plan</div>
            </div>
        </div>

        <div class="menu_close-btn button-17" (click)="changeState(LayoutState.expanded)">Close</div>
    </div>
</ng-container>
